export const OPEN_MODAL = 'OPEN_MODAL';

export const WATERFALL_GRAPH_LIST = 'WATERFALL_GRAPH_LIST';
export const WATERFALL_GRAPH_LIST_SUCCESS = 'WATERFALL_GRAPH_LIST_SUCCESS';
export const WATERFALL_GRAPH_LIST_ERROR = 'WATERFALL_GRAPH_LIST_ERROR';
export const WATERFALL_GRAPH_UPDATE_DATA = 'WATERFALL_GRAPH_UPDATE_DATA';